import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as organisationModule from 'modules/organisation'

export default compose(
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected),
        organisations: idx(state, _ => _.organisation.items)
      }
    }, 
    (dispatch) => {
      const actions = {
        ...organisationModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      loaded: true,
      selectedOrganisation: null,
    }),
    {
      setState: state => object => ({
        ...state,
        ...object
      }),
    }
  ),
  withHandlers({
    onOrganisationSelect: ({ setState, organisations }) => (selectedOrganisation) => {
      setState({
        selectedOrganisation: organisations[selectedOrganisation],
      })
    },
    onConfirmClick: ({ data, selectedOrganisation }) => () => {
      data.onConfirm(selectedOrganisation)
    }, 
  }),
  
  lifecycle({
    componentDidMount() {
      const { actions } = this.props
      actions.getOrganisations()
    },
    componentDidUpdate(prevProps) {
      const {
        actions, search, setState, loaded, organisation 
      } = this.props

      if (prevProps.search !== search && !loaded) {
        actions.getOrganisations(organisation, { search }, () => {
          setState({ loaded: true })
        })
      }
    }
  }),
)



// WEBPACK FOOTER //
// ./src/components/organisms/TransferTrapsPopover/TransferTrapsPopover.enhancer.js